import script from "./BasePasswordForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./BasePasswordForm.vue?vue&type=script&lang=ts&setup=true"

import "./BasePasswordForm.vue?vue&type=style&index=0&id=238a6f00&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-238a6f00"]])

export default __exports__